module.exports = __webpack_public_path__ + "static/media/Search.074e6f03.svg";